/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_Basis_ValueInputs */

const cs_deals_basis_value = /** @type {(inputs: Deals_Basis_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Základ obchodu`)
};

const en_deals_basis_value = /** @type {(inputs: Deals_Basis_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal basis`)
};

/**
* | output |
* | --- |
* | "Deal basis" |
*
* @param {Deals_Basis_ValueInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_basis_value = /** @type {((inputs?: Deals_Basis_ValueInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_Basis_ValueInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_basis_value(inputs)
	return cs_deals_basis_value(inputs)
});